export function validateGreenToRedCandles(data) {
  const { retracePct, candleDuration } = data;
  if (retracePct <= 0)
    return [false, 'Retrace percentage must be larger than zero.'];
  if (
    !candleDuration ||
    candleDuration <= 0 ||
    !Number.isInteger(candleDuration)
  )
    return [false, 'Candle duration must be a whole number larger than zero.'];
  return [true, ''];
}
